import {
  ApolloClient,
  ApolloProvider,
  HttpLink,
  InMemoryCache,
  createHttpLink,
  from,
} from '@apollo/client'
import { setContext } from '@apollo/client/link/context'
import { getCookie } from 'utils/cokie'
import getErrorLink from './errorlinks'
import { performanceLink } from './performanceLink'
import { v4 as uuidv4 } from 'uuid'
import { useNavigate } from 'react-router-dom'
import { useAppDispatch } from 'hooks/redux-hooks'

type GraphqlOperation = {
  getContext: () => {
    graphqlUrl?: string
  }
}

const getGraphqlUri = (operation: GraphqlOperation) =>
  operation.getContext().graphqlUrl || process.env.REACT_APP_GRAPHQL_URL

const httpLink = createHttpLink({
  uri: getGraphqlUri,
  credentials: 'same-origin',
})

const httpLink1 = new HttpLink({
  uri: getGraphqlUri,
})

const authLink = setContext((_, context) => {
  const { headers = {}, isAuthRequired = true } = context || {}
  // get the authentication token from local storage if it exists
  const token = getCookie('access_token')
  // return the headers to the context so httpLink can read them
  if (isAuthRequired) {
    return {
      headers: {
        'x-access-token': `Bearer ${token}`,
        'X-IDEMPOTENCY-ID': uuidv4(),
        ...headers,
      },
    }
  }
  return {
    headers: {
      ...headers,
    },
  }
})
let client

export const getApolloAuthClient = () => {
  const client = new ApolloClient({
    link: from([performanceLink, authLink.concat(httpLink)]),
    cache: new InMemoryCache({
      addTypename: false,
    }),
  })

  return client
}
export const getApolloClient = (dispatch, navigate) => {
  if (!client) {
    const errorLink = getErrorLink(dispatch, navigate)

    client = new ApolloClient({
      link: from([errorLink, performanceLink, authLink.concat(httpLink1)]),
      cache: new InMemoryCache({
        addTypename: false,
      }),
      defaultOptions: {
        watchQuery: {
          fetchPolicy: 'network-only', // Used for first execution
          nextFetchPolicy: 'network-only',
        },
      },
    })
  }
  return client
}
export default function ApolloClientProvider({ children }) {
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const apolloClient = getApolloClient(dispatch, navigate)
  return <ApolloProvider client={apolloClient}>{children}</ApolloProvider>
}
